<template>
    <div class="bg-gray-50 min-h-screen">
        <!-- 页面标题区 -->
        <section class="bg-primary relative overflow-hidden">
            <div class="absolute inset-0 bg-black bg-opacity-20 bg-banner"></div>
            <div class="container mx-auto px-6 py-16 relative z-10">
                <h1 class="text-3xl md:text-4xl font-bold text-white mb-4 text-center">Latest News</h1>
                <p class="text-white text-center max-w-2xl mx-auto">
                    Stay updated with the latest industry news, product releases, and company updates
                </p>
            </div>
        </section>

        <!-- 新闻列表区 -->
        <section class="py-12">
            <div class="container mx-auto px-6">
                <!-- 新闻九宫格 -->
                <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-10">
                    <!-- 新闻项（循环生成） -->
                    <div v-for="(news, index) in newsData" :key="index"
                        class="bg-white rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1">
                        <router-link :to="{
                            name: 'NewsDetail',
                            params: { NewsId: news.id } 
                        }" class="product-card bg-white rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-shadow group">
                            <div class="relative h-48 overflow-hidden">
                                <img :src="news.coverOssUrl" :alt="news.title"
                                    class="w-full h-full object-cover transition-transform duration-500 hover:scale-110">
                                <!-- <div class="absolute top-3 left-3 bg-primary text-white text-xs px-2 py-1 rounded">
                                    {{ news.summary }}
                                </div> -->
                            </div>
                            <div class="p-5">
                                <div class="flex items-center text-gray-500 text-sm mb-3">
                                    <i class="fa fa-calendar-o mr-2"></i>
                                    <span>{{ formatDate(news.pubTime) }}</span>
                                </div>
                                <h3
                                    class="text-lg font-semibold text-gray-800 mb-2 line-clamp-2 hover:text-primary transition-colors">
                                    {{ news.title }}
                                </h3>
                                <p class="text-gray-600 text-sm mb-4 line-clamp-2">
                                    {{ news.summary }}
                                </p>
                                <a href="#"
                                    class="inline-flex items-center text-primary font-medium hover:underline text-sm">
                                    Read More <i class="fa fa-long-arrow-right ml-2"></i>
                                </a>
                            </div>
                        </router-link>
                    </div>
                </div>
                <Pagination :current-page="pageNum" :total="total" :page-size="pageSize"
                    @page-change="handlePageChange" />

            </div>
        </section>
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import Pagination from '@/components/Pagination.vue';
import { pageNews } from '@/api/news'
// 分页逻辑
const pageNum = ref(1)
const newsData = ref([])
const total = ref(0)
const pageSize = ref(6)
onMounted(() => {
    getListNews()
})
const getListNews = async () => {
    let res = await pageNews({
        pubStatus: 2,
        pageNum: pageNum.value,
        pageSize: pageSize.value
    })
    newsData.value = res.rows
    total.value = res.total

    console.log(res, 'pageNews')
}
// 处理页码变更
const handlePageChange = (newPage) => {
    pageNum.value = newPage;
    getListNews()
};

// 日期格式化
const formatDate = (dateString) => {
    const options = { year: 'numeric', month: 'long', day: 'numeric' }
    return new Date(dateString).toLocaleDateString('en-US', options)
}

</script>

<style scoped>
.bg-banner {
    background-image: linear-gradient(to right, rgba(26, 32, 44, 0.8), rgba(26, 32, 44, 0.5), rgba(26, 32, 44, 0.8)),
        url('@/assets/images/news-banner-new.jpg');
    background-size: cover;
    background-position: center;
}

/* 分页样式优化 */
button:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    pointer-events: all;
}

button:disabled:hover {
    background-color: transparent;
}

/* 新闻卡片交互效果 */
.line-clamp-2:hover {
    text-decoration: underline;
}

/* 响应式调整 */
@media (max-width: 640px) {
    .grid-cols-1 {
        gap: 4rem;
    }

    .relative.h-48 {
        height: 36vh;
    }

    .absolute.inset-0 {
        background-position: top;
    }

    /* 移动端分页优化 */
    .flex.items-center.gap-2 {
        flex-wrap: wrap;
        justify-content: center;
    }
}
</style>